import { render, staticRenderFns } from "./EventExpansionPanel.vue?vue&type=template&id=2b3de8ae&scoped=true&lang=pug"
import script from "./EventExpansionPanel.vue?vue&type=script&lang=js"
export * from "./EventExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./EventExpansionPanel.vue?vue&type=style&index=0&id=2b3de8ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3de8ae",
  null
  
)

export default component.exports